<template>
  <Loading v-if="!skeleton.shopsLoaded" page="shops" />
  <div v-show="skeleton.shopsLoaded" :class="{ 'fade-in': skeleton.shopsLoaded }">
    <header-middle />
    <bread-crumb :vector="cash.mainVectors[route.params.item]" />
    <div class="mx-4">
      <banner-temp :mode="'Shops' + route.params.item" />
    </div>
    <store-list :list="cash.shops[route.params.item]" />
    <footer-template />
  </div>
</template>

<script setup>
import HeaderMiddle from "../section/header/header.vue";
import FooterTemplate from "../section/footer/footer.vue";
import BreadCrumb from "../section/item/BreadCrumb.vue";
import StoreList from "../section/pages/Shops/items.vue";
import BannerTemp from "../section/item/BannerTemp.vue";
import Loading from "../section/item/loading.vue";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useCash } from "@/store/cash";
import { useSkeleton } from "@/store/skeleton";
const skeleton = useSkeleton();
let route = useRoute();
const cash = useCash();
let newPage = computed(() => route.params);
watch(
  newPage,
  () => {
    cash.getShops(route.params.item);
  },
  { immediate: true }
);
</script>

